/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by jessenelson on 2/3/16.
 */
'use strict';
angular.module('prism-ui.calendars').factory('CalendarColumnsFactory', function () {

	var buildLiveColumns = function () {
		var returnValue = [];
		var feedColumn = {
			field: 'feed',
			minWidth: 200,
			width: 200,
			cellTemplate: 'components/visual/grid/base-tooltip-template.html',
			enableColumnResizing: false
		};
		returnValue.push(feedColumn);
		for (var i = 0; i < 24; i++) {
			var obj = {
				field: i + '',
				width: 60,
				minWidth: 60,
				cellTemplate: 'dashboard/calendars/base/gridTemplates/live-calendar-cell-template.html',
				enableColumnResizing: true
			};
			if (i === 0) {
				obj.displayName = '12 am';
			}
			else if (i <= 11) {
				obj.displayName = i + ' am';
			}
			else if (i === 12) {
				obj.displayName = '12 pm';
			}
			else {
				obj.displayName = (i - 12) + ' pm';
			}
			returnValue.push(obj);
		}
		return returnValue;
	};

	return {
		dueDateColumns: [
			{
				field: 'status',
				name: 'statusIcon',
				displayName: '',
				width: 30,
				minWidth: 30,
				enableColumnResizing: false,
				enableSorting: false,
				cellTemplate: 'dashboard/calendars/base/gridTemplates/status-column-template.html'
			},
			{
				field: 'proxyId',
				enableColumnMenu: false,
				name: 'playIconColumn',
				displayName: '',
				width: 30,
				minWidth: 30,
				enableSorting: false,
				enableColumnResizing: false,
				cellTemplate: 'dashboard/calendars/base/gridTemplates/play-icon-column-template.html'
			},
			{
				field: 'dueDate',
				displayName: 'First Due',
				width: 200,
				cellTemplate: 'components/visual/grid/date-time-noseconds-column-template.html'
			},
			{
				field: 'warningDueDate',
				displayName: 'First Warning',
				width: 200,
				cellTemplate: 'components/visual/grid/date-time-noseconds-column-template.html'
			},
            {
                field: 'instanceId',
                displayName: 'Instance',
                width: 75,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'instanceRevision',
                displayName: 'Revision',
                width: 75,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
			{
				field: 'status',
				displayName: 'Package Status',
				width: 175,
				cellTemplate: 'components/visual/grid/base-tooltip-template.html'
			},
			{
				field: 'partnerName',
				displayName: 'Partner',
				width: 175,
				cellTemplate: 'components/visual/grid/base-tooltip-template.html'
			},
			{
				field: 'networkName',
				displayName: 'Network',
				width: 175,
				cellTemplate: 'components/visual/grid/base-tooltip-template.html'
			},
			{
				field: 'contentName',
				displayName: 'Series/Movie/Ad',
				width: 175,
				cellTemplate: 'components/visual/grid/base-tooltip-template.html'
			},
			{
				field: 'episodeTitle',
				displayName: 'Title',
				width: 175,
				cellTemplate: 'components/visual/grid/base-tooltip-template.html'
			},
			{
				field: 'productionNumber',
				displayName: 'Prod No.',
				width: 125,
				cellTemplate: 'components/visual/grid/base-tooltip-template.html'
			},
			{
				field: 'categoryName',
				displayName: 'Category',
				width: 125,
				cellTemplate: 'components/visual/grid/base-tooltip-template.html'
			},
			{
				field: 'metaErrorCount',
				displayName: 'Meta Valid',
				minWidth: 100,
				cellTemplate: 'package/manager/gridTemplates/metadata-error-count-template.html'
			},
			{
				field: 'mediaErrorCount',
				displayName: 'Media Valid',
				width: 100,
				cellTemplate: 'package/manager/gridTemplates/media-error-count-template.html'
			},
			{
				field: 'acceptStatus',
				name: 'Approved',
				width: 100,
				cellTemplate: 'package/manager/gridTemplates/accept-status-template.html'
			}

		],
		ordColumns: [
			{
				field: 'status',
				name: 'statusIcon',
				displayName: '',
				width: 30,
				minWidth: 30,
				enableColumnResizing: false,
				enableSorting: false,
				cellTemplate: 'dashboard/calendars/base/gridTemplates/status-column-template.html'
			},
			{
				field: 'proxyId',
				enableColumnMenu: false,
				name: 'playIconColumn',
				displayName: '',
				width: 30,
				minWidth: 30,
				enableSorting: false,
				enableColumnResizing: false,
				cellTemplate: 'dashboard/calendars/base/gridTemplates/play-icon-column-template.html'
			},
			{
				field: 'status',
				displayName: 'Package Status',
				width: 175,
				cellTemplate: 'components/visual/grid/base-tooltip-template.html'
			},
			{
				field: 'networkName',
				displayName: 'Network',
				width: 175,
				cellTemplate: 'components/visual/grid/base-tooltip-template.html'
			},
			{
				field: 'contentName',
				displayName: 'Series/Movie/Ad',
				width: 300,
				cellTemplate: 'components/visual/grid/base-tooltip-template.html'
			},
			{
				field: 'episodeTitle',
				displayName: 'Title',
				width: 300,
				cellTemplate: 'components/visual/grid/base-tooltip-template.html'
			},
			{
				field: 'productionNumber',
				displayName: 'Prod No.',
				width: 125,
				cellTemplate: 'components/visual/grid/base-tooltip-template.html'
			},
			{
				field: 'airTime',
				displayName: 'Air Time',
				width: 125,
				cellTemplate: 'components/visual/grid/time-column-template.html'
			},
			{
				field: 'categoryName',
				displayName: 'Category',
				width: 125,
				cellTemplate: 'components/visual/grid/base-tooltip-template.html'
			},
			{
				field: 'metaErrorCount',
				displayName: 'Meta Valid',
				minWidth: 100,
				maxWidth: 100,
				cellTemplate: 'package/manager/gridTemplates/metadata-error-count-template.html'
			},
			{
				field: 'mediaErrorCount',
				displayName: 'Media Valid',
				width: 100,
				maxWidth: 100,
				cellTemplate: 'package/manager/gridTemplates/media-error-count-template.html'
			},
			{
				field: 'acceptStatus',
				name: 'Approved',
				width: 100,
				maxWidth: 100,
				cellTemplate: 'package/manager/gridTemplates/accept-status-template.html'
			}
		],
		firstLaunchColumns: [
			{
				field: 'status',
				name: 'statusIcon',
				displayName: '',
				width: 30,
				minWidth: 30,
				enableColumnResizing: false,
				enableSorting: false,
				cellTemplate: 'dashboard/calendars/base/gridTemplates/status-column-template.html'
			},
			{
				field: 'proxyId',
				enableColumnMenu: false,
				name: 'playIconColumn',
				displayName: '',
				width: 30,
				minWidth: 30,
				enableSorting: false,
				enableColumnResizing: false,
				cellTemplate: 'dashboard/calendars/base/gridTemplates/play-icon-column-template.html'
			},
			{
				field: 'status',
				displayName: 'Package Status',
				width: 175,
				cellTemplate: 'components/visual/grid/base-tooltip-template.html'
			},
			{
				field: 'networkName',
				displayName: 'Network',
				width: 175,
				cellTemplate: 'components/visual/grid/base-tooltip-template.html'
			},
			{
				field: 'partnerNames',
				displayName: 'Partner',
				width: 175,
				cellTemplate: 'components/visual/grid/comma-seperated-array-template.html'
			},
			{
				field: 'contentName',
				displayName: 'Series/Movie/Ad',
				width: 300,
				cellTemplate: 'components/visual/grid/base-tooltip-template.html'
			},
			{
				field: 'episodeTitle',
				displayName: 'Title',
				width: 300,
				cellTemplate: 'components/visual/grid/base-tooltip-template.html'
			},
			{
				field: 'productionNumber',
				displayName: 'Prod No.',
				width: 125,
				cellTemplate: 'components/visual/grid/base-tooltip-template.html'
			},
			{
				field: 'earliestLaunchDate',
				displayName: 'Launch Time',
				width: 125,
				cellTemplate: 'components/visual/grid/time-from-date-template.html'
			},
			{
				field: 'categoryName',
				displayName: 'Category',
				width: 125,
				cellTemplate: 'components/visual/grid/base-tooltip-template.html'
			},
			{
				field: 'metaErrorCount',
				displayName: 'Meta Valid',
				minWidth: 100,
				maxWidth: 100,
				cellTemplate: 'package/manager/gridTemplates/metadata-error-count-template.html'
			},
			{
				field: 'mediaErrorCount',
				displayName: 'Media Valid',
				width: 100,
				maxWidth: 100,
				cellTemplate: 'package/manager/gridTemplates/media-error-count-template.html'
			},
			{
				field: 'acceptStatus',
				name: 'Approved',
				width: 100,
				maxWidth: 100,
				cellTemplate: 'package/manager/gridTemplates/accept-status-template.html'
			}
		],
		liveRecordingsColumns: buildLiveColumns()
	};
});
